import { Select } from '@seiue/ui'
import React from 'react'
import styled from 'styled-components'

import { createMultiOptions } from './utils'

/**
 * 多选 - 选项数量设置
 *
 * @param param - 参数
 * @param param.maxCount - 最大数量
 * @param param.minCount - 最小数量
 * @param param.optionsLen - 选项长度
 * @param param.isUserField - 是否是用户字段题型
 * @param param.onChange - 数量发生变化时的回调
 * @returns React.ReactNode
 */
export const OptionNumSetting: React.FC<{
  maxCount: number
  minCount: number
  optionsLen: number
  onChange: (param: object) => void
  isUserField?: boolean
}> = ({ maxCount, minCount, optionsLen, onChange, isUserField }) => {
  const isError = maxCount && minCount && maxCount < minCount
  const numError = maxCount > optionsLen || minCount > optionsLen

  const options = createMultiOptions(optionsLen || 2)

  return (
    <Wrapper>
      <SettingWrapper>
        <div>最少</div>
        <Select
          disabled={!!isUserField}
          options={options}
          value={minCount || 0}
          onChange={(v) => onChange({ minCount: Number(v) })}
          status={isError ? 'error' : undefined}
        />
      </SettingWrapper>
      <SettingWrapper>
        <div>最多</div>
        <Select
          disabled={!!isUserField}
          options={options}
          value={maxCount || 0}
          onChange={(v) => onChange({ maxCount: Number(v) })}
          status={isError ? 'error' : undefined}
        />
      </SettingWrapper>
      {!isError && numError ? (
        <ErrorWrapper>可选数量设置冲突，请调整</ErrorWrapper>
      ) : null}
      {isError ? (
        <ErrorWrapper>最多可选数量需 ≥ 最少可选数量</ErrorWrapper>
      ) : null}
    </Wrapper>
  )
}

const Wrapper = styled.div``

const SettingWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  &:last-child {
    margin-bottom: 0;
  }
  & > div {
    font-size: 14px;
    font-weight: 400;
    color: ${(props) => props.theme.text._2};
  }
  &&& {
    .ant-select-selector {
      border: 1px solid transparent;
      border-radius: 8px;
      background-color: ${(props) => props.theme.background._3};
    }
    .ant-select-focused .ant-select-selector {
      border: 1px solid transparent;
    }
    .ant-select {
      width: 236px;
      height: 32px;
      border-radius: 8px;
    }
  }
`

const ErrorWrapper = styled.div`
  font-size: 12px;
  color: #f54545;
  margin-left: 44px;
`
